<div class="page">
  <app-widget-card height="400px">
    <div class="flex flex-col center justify-center full-height gap-16">
        <img src="assets/icons/ic_farfisa_logo.png" />
        <img src="assets/icons/ic_app_icon_prod.svg" />
        <div class="headline">Redirect...</div>
    </div>
  </app-widget-card>
</div>
